import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 还款状态
 */
class RepaymentState extends UltMeta {
    TO_BE_DEDUCTION = new Meta(1, "待扣款");
    BANK_REJECTED = new Meta(2, "银行驳回");
    DEDUCTION_COMPLETED = new Meta(3, "扣款完成");
    RELEASED = new Meta(4, "额度已释放");
}

export const REPAYMENT_STATE = new RepaymentState();

/**
 * 供应商端 列表筛选 还款状态
 */
class RepaymentStateAdmin extends UltMeta {
    DEDUCTION_COMPLETED = new Meta(3, "扣款完成");
    RELEASED = new Meta(4, "额度已释放");
}

export const REPAYMENT_STATE_ADMIN = new RepaymentStateAdmin();
/**
 * 银行端还款状态
 */
class RepaymentStateBank extends UltMeta {
    TO_BE_DEDUCTION = new Meta(1, "待扣款");
    DEDUCTION_COMPLETED = new Meta(3, "扣款完成");
    RELEASED = new Meta(4, "额度已释放");
}

export const REPAYMENT_STATE_BANK = new RepaymentStateBank();

class RepaymentMethod extends UltMeta {
    PRINCIPAL_REPAYMENT = new Meta(1, "还本");
    INTEREST_REPAYMENT = new Meta(2, "还息");
    PRINCIPAL_INTEREST = new Meta(3, "本息");
}

export const REPAYMENT_METHOD = new RepaymentMethod();
